import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { app } from '../../base'
import { secondaryApp } from '../../baseSecondary'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class AddUser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      show: 'none'
    }
  }

  createNew(event) {
    event.preventDefault()

    const name = this.nameInput.value
    const email = this.emailInput.value
    const userType = this.typeInput.value
    const password = this.passwordInput.value
    //console.log(name+"-"+email+"-"+userType+"-"+password)

    if (name == '' || email == '' || password == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    secondaryApp.auth().createUserWithEmailAndPassword(email, password).then((user) => {
      user.updateProfile({
        displayName: name
      }).then(()=>{
        //console.log("username udpated");
        app.database().ref('users/' + user.uid).set({
          create_time: new Date().getTime(),
          created_by: app.auth().currentUser.email,
          email: email,
          status: 1,
          user_name: name,
          user_type: parseInt(userType)
        }).then(()=>{
          this.setMessage('User Added Successfully');
        }).catch((error)=>{
          this.deleteUser(user);
          this.setMessage(error.message);
        });
      }).catch((error)=>{
        this.deleteUser(user);
        this.setMessage(error.message);
      });

      secondaryApp.auth().signOut();
      this.entryForm.reset()
    })
    .catch((error) => {
      this.setMessage(error.message);
    });
  }

  deleteUser(user) {
    user.delete().then(function() {
      //console.log("user deleted");
    }).catch(function(error) {
      //console.log(error.message);
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.createNew(event) }} ref={(form) => { this.entryForm = form }}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon><i className="icon-user"></i></InputGroupAddon>
                      <Input type="text" placeholder="Username" innerRef={(input) => { this.nameInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroupAddon>@</InputGroupAddon>
                      <Input type="text" placeholder="Email" innerRef={(input) => { this.emailInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroupAddon><i className="fa fa-user-circle"></i></InputGroupAddon>
                      <Input type="select" name="user-type" innerRef={(input) => { this.typeInput = input }}>
                        <option value="2">Shop owner</option>
                        <option value="3">Delivery Man</option>
                        <option value="1">Super Admin</option>
                      </Input>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroupAddon><i className="icon-lock"></i></InputGroupAddon>
                      <Input type="password" placeholder="Password" innerRef={(input) => { this.passwordInput = input }} />
                    </InputGroup>
                    <Button color="success" block>Submit</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default AddUser;


// WEBPACK FOOTER //
// ./src/views/Users/Add.js